import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useAuth } from "../lib/auth-context";

/**
 * Attaches OPAQUE identifiers (user_id, workspace_id) to Sentry so a frontend
 * error can be correlated to a support report — no names/emails. Read-only:
 * consumes the auth context, never modifies it. No-op when Sentry is disabled.
 */
export default function SentryIdentity() {
  const { user, member } = useAuth();
  useEffect(() => {
    try {
      if (user?.user_id) Sentry.setUser({ id: user.user_id });
      else Sentry.setUser(null);
      if (member?.workspace_id) Sentry.setTag("workspace_id", member.workspace_id);
    } catch {
      /* observability must never break the app */
    }
  }, [user?.user_id, member?.workspace_id]);
  return null;
}
